module.exports = __webpack_public_path__ + "static/media/golf-cart.74433efa.svg";